import { Button, Flex } from 'antd';
import dayjs from 'dayjs';

import { CardRangePicker, getTimeDistance, RangePickerValue, TimeType } from 'src/components/card-range-picker';
import { IllegalTypeSelect } from 'src/features/illegal-type';

import { useReportSearch } from './illegal-handle.context';

const SearchForm: React.FC = () => {
  const [{ rangePickerValue, code }, , dispatch] = useReportSearch();
  const isActive = (type: TimeType) => {
    if (!rangePickerValue) {
      return '';
    }
    const value = getTimeDistance(type);
    if (!value) {
      return '';
    }
    if (!rangePickerValue[0] || !rangePickerValue[1]) {
      return '';
    }
    if (
      rangePickerValue[0].isSame(value[0] as dayjs.Dayjs, 'day') &&
      rangePickerValue[1].isSame(value[1] as dayjs.Dayjs, 'day')
    ) {
      return 'currentDate';
    }
    return '';
  };

  const selectDate = (type: TimeType) => {
    const dates = getTimeDistance(type);
    dispatch.setDateRange(dates);
  };

  const selectDateRange = (dates: RangePickerValue) => {
    dispatch.setDateRange(dates);
  };
  return (
    <Flex>
      <CardRangePicker
        rangePickerValue={rangePickerValue}
        isActive={isActive}
        handleRangePickerChange={selectDateRange}
        selectDate={selectDate}
      />

      <IllegalTypeSelect
        allowClear
        onChange={dispatch.setCode}
        style={{ minWidth: 200, marginRight: 16 }}
        value={code?.[0]}
      />

      <Button type="primary" onClick={dispatch.submitSearch}>
        查询
      </Button>
    </Flex>
  );
};

export default SearchForm;
